import { Component, ViewEncapsulation, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { MENU_ITEMS } from './../../admin.menu-items';
import { MenuItem, User } from '@shared/data';

@Component({
  selector: 'layout',
  styles: [ require('./layout.component.scss') ],
  template: require('./layout.component.html')
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  public isOpen: boolean;
  public user: User;
  public error: Parse.Error;

  public menuItems = MENU_ITEMS;

  constructor(private router: Router, translateService: TranslateService) {
    translateService.setDefaultLang('en');
    translateService.use('en');
  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit(): void {

  }

  public ngAfterViewInit() {
    this.user = User.current();
  }

  public ngOnDestroy() {

  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onLogout() {
    Parse.User.logOut().then(
      (result: Parse.User) => {
        this.router.navigate(['admin/login']);
      },
      (error: Parse.Error) => {

      }
    );
  }
}





// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/components/layout/layout.component.ts